import {useEffect} from 'react';
import {
    FormattedMessage,
    useIntl,
} from 'react-intl';
import {BackLink} from '../../../components';
import {useAmplitude} from '../../../context';
import {useLinearFlowContext} from '../../../layouts';
import {
    ContinueButton,
    Instruction,
} from '../components';

export function SwapAndShake() {
    const amplitude = useAmplitude();
    const intl = useIntl();
    const {onBackLinkClickHandler} = useLinearFlowContext();

    useEffect(() => {
        amplitude.logActivationShakeVisit();
    }, [amplitude]);

    return (
        <>
            <BackLink onClick={onBackLinkClickHandler} />
            <h2 data-test-id={'kit-activation-step-four-title'}>
                <FormattedMessage id={'kit.activation.stepFour.title'} />
            </h2>
            <Instruction
                image={'/images/kit-activation-four-one.svg'}
                text={intl.formatMessage({id: 'kit.activation.stepFour.instruction.one'})}
            />
            <Instruction
                className={'more-margin'}
                image={'/images/kit-activation-four-two.svg'}
                text={intl.formatMessage({id: 'kit.activation.stepFour.instruction.two'})}
            />
            <ContinueButton />
        </>
    );
}
